module.exports = __webpack_public_path__ + "img/bg.47207c6d.png";